module.exports = "/_next/static/images/Pin_locked-4268938f7becfe81d38f53fe7dcd589b.png";